export default __webpack_public_path__ + "static/media/overview_active.55e9f63d.svg";